import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../../../../lib/useQuery/queryKeys";
import { createCrmProject } from ".";

export function useCreateCrmProject() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: queryKeys.crm_project._def,
    mutationFn: createCrmProject,
    onSuccess: ()=>{
      queryClient.invalidateQueries({queryKey: queryKeys.crm_project._def, exact: false});
    }
  })
}